import React from 'react';
import { useTranslation } from 'react-i18next';

export type BillingTab = 'transactions' | 'balances';

interface BillingTabsProps {
  activeTab: BillingTab;
  onTabChange: (tab: BillingTab) => void;
}

const BillingTabs: React.FC<BillingTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-6">
          <button
            onClick={() => onTabChange('transactions')}
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'transactions'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center space-x-1">
              <span>📊</span>
              <span>{t('billing.tabs.transactions')}</span>
            </div>
          </button>
          <button
            onClick={() => onTabChange('balances')}
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'balances'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center space-x-1">
              <span>👥</span>
              <span>{t('billing.tabs.balances')}</span>
            </div>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default BillingTabs;
